import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const ProspectingClientContainer = styled.div`
  width: 100%;
`;

export const ProspectingClientWrapper = styled.div`
  width: 100%;
  max-width: 650px;
  margin: auto;
`;

export const ProspectingClientSubtitle = styled.p`
  font-weight: 400;
  color: ${colors.textSecondary};
  text-align: center;
  font-size: 32px;
  line-height: 23px;
`;

export const ProspectingClientInfo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 32px 1fr;
  align-items: center;
  margin-top: 40px;
`;

export const ProspectingClientIcon = styled.div`
  background: ${colors.bgTertiary};
  box-shadow: 0px 5px 10px ${colors.bgTertiaryShadow};
  border-radius: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProspectingClientInfoParagraph = styled.span`
  font-size: 12px;
  line-height: 23px;
  margin-left: auto;
  margin-right: auto;
  color: ${colors.textPrimary};
`;
